import cloneDeep from "lodash/cloneDeep";
import throttle from "lodash/throttle";
import Pagination from "rc-pagination";
import "rc-pagination/assets/index.css";
import React, { useEffect, useState } from "react";
import { allData } from "./constant";
import "./TableSearchPagination.css";
import axios from "axios";
import { useParams } from "react-router-dom";
import swal from "sweetalert";
import { serverInfo } from "../../../../../App";
import { useContext } from "react";
import { Table } from "react-bootstrap";

const tableHead = {
  photo: "Photo",
  name: "Name",
  mobile: "Mobile",
  email: "Email",
  mart: "Mart",
  action: "Actions",
};

const LearningSessionEvaluationMarkSheet = () => {
  const { videoCdnUrl } = useContext(serverInfo);
  const [videos, setVideos] = useState("");
  const [event, setEvent] = useState([]);
  const [complete, setComplete] = useState(false);

  const countPerPage = 10;
  const [value, setValue] = React.useState("");
  const [currentPage, setCurrentPage] = React.useState(1);
  const [collection, setCollection] = React.useState(
    cloneDeep(allData.slice(0, countPerPage))
  );
  const searchData = React.useRef(
    throttle((val) => {
      const query = val.toLowerCase();
      setCurrentPage(1);
      const data = cloneDeep(
        allData
          .filter((item) => item.name.toLowerCase().indexOf(query) > -1)
          .slice(0, countPerPage)
      );
      setCollection(data);
    }, 400)
  );

  React.useEffect(() => {
    if (!value) {
      updatePage(1);
    } else {
      searchData.current(value);
    }
  }, [value]);

  const updatePage = (p) => {
    setCurrentPage(p);
    const to = countPerPage * p;
    const from = to - countPerPage;
    setCollection(cloneDeep(allData.slice(from, to)));
  };

  const tableRows = (rowData) => {
    const { key, index } = rowData;
    const tableCell = Object.keys(tableHead);
    const columnData = tableCell.map((keyD, i) => {
      return (
        <td className="tdCell" key={i}>
          {key[keyD]}
        </td>
      );
    });

    return (
      <tr className="trCell" key={index}>
        {columnData}
      </tr>
    );
  };

  const tableData = () => {
    return collection.map((key, index) => tableRows({ key, index }));
  };

  const headRow = () => {
    return Object.values(tableHead).map((title, index) => (
      <td className="tdCell" key={index}>
        {title}
      </td>
    ));
  };

  let { slug } = useParams();

  const fetchData = (slug) => {
    axios
      .get(`/api/admin/learning_session/assignment/marks/${slug}`)
      .then((res) => {
        if (res.status === 200) {
          setEvent(res.data.event);
          setVideos(res.data.event?.learning_session_assignment);
          setComplete(res.data.complete);
        }
      });
  };

  useEffect(() => {
    fetchData(slug);
  }, [slug]);

  const sendToMangerHandler = () => {
    axios
      .get(`/api/admin/learning_session/assignment/send_to_manager/${slug}`)
      .then((res) => {
        if (res.data.status === 200) {
          fetchData(slug);
          swal("Success", res.data.message, "success");
        }
      });
  };

  return (
    <div className="">
      <div className="search mb-3">
        <input
          className="inputSearch"
          placeholder="Search"
          value={value}
          onChange={(e) => setValue(e.target.value)}
        />
      </div>

      <div className="row mx-1" style={{ overflowX: "auto" }}>
        <Table className="table w-100" striped bordered hover variant="dark">
          <thead>
            <tr>
              <th lassName="bg-warning text-center">SL</th>
              <th lassName="bg-warning text-center">Videos</th>
              <th lassName="bg-warning text-center">Mark</th>
              <th lassName="bg-warning text-center">Evaluator</th>
              <th lassName="bg-warning text-center">status</th>
              <th lassName="bg-warning text-center">Send to Manager</th>
            </tr>
          </thead>
          <tbody>
            {videos &&
              videos.map((item, index) => (
                <tr>
                  <td className="tdCell">{index + 1}</td>
                  <td className="tdCell">
                    <video
                      height={100}
                      width={160}
                      style={{ cursor: "pointer" }}
                    >
                      <source
                        src={
                          item.video != null
                            ? videoCdnUrl + item.video
                            : "https://youtu.be/dgfTiONcnTc"
                        }
                        type="video/mp4"
                      />
                    </video>
                  </td>
                  <td className="tdCell">{item.mark}</td>
                  <td className="tdCell">
                    {item.send_to_star === 1 ? (
                      <b className="twxt-warning">Star</b>
                    ) : item.status === 1 &&
                      item.mark === 0 &&
                      item.send_to_star === 0 ? (
                      <b className="twxt-warning">Approved Only</b>
                    ) : item.send_to_star === 0 && item.mark > 0 ? (
                      <b className="twxt-light">Admin</b>
                    ) : (
                      ""
                    )}
                  </td>
                  <td className="tdCell">
                    {item.status < 2 && item.mark === 0 ? (
                      <span className="text-warning">Pending</span>
                    ) : item.status === 2 ? (
                      <span className="text-danger">Rejected</span>
                    ) : (
                      <span className="text-success">Done</span>
                    )}
                  </td>
                  <td className="tdCell">
                    {item.send_to_manager === 1 ? (
                      <i className="fa-solid fa-check text-success"></i>
                    ) : (
                      <i className="fa-solid fa-close text-danger"></i>
                    )}
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>
      </div>
      <div className="learningSessionPagination">
        <Pagination
          pageSize={countPerPage}
          onChange={updatePage}
          current={currentPage}
          total={videos.length}
        />
      </div>

      {complete ? (
        event?.status < 6 ? (
          <>
            <button
              className="btn mt-4 fw-bold mx-2 BTBbtn"
              onClick={sendToMangerHandler}
            >
              <h5 className="fw-bold">Send To The Manager</h5>
            </button>
          </>
        ) : (
          <></>
        )
      ) : (
        ""
      )}
    </div>
  );
};
export default LearningSessionEvaluationMarkSheet;
